import { Observable } from 'rxjs';
import { ComponentDataSourceService } from '../../component-data-source.service';

export function add_event_users(componentDataSourceService: ComponentDataSourceService) {
    // Function to handle status changes
    const handleStatusChange = (newValue: string, rowData: any) => {
      // Here you would add the API call to update the backend
    };

    return {
      name: 'Event Users',
      description: 'Shows all users signed up for the event and their participation status',
      execute: () => {
        return new Observable(subscriber => {
          subscriber.next([
            {
              full_name: 'John Doe',
              participation_status: 'shownup'
            },
            {
              full_name: 'Jane Smith',
              participation_status: 'completed'
            },
            {
              full_name: 'Mike Johnson',
              participation_status: 'pending'
            }
          ]);
          subscriber.complete();
        });
      },
      settings: {
        columns: [
          { key: 'full_name', header: 'Fulde navn', type: 'text' },
          { 
            key: 'participation_status', 
            header: 'Deltagelse', 
            type: 'select',
            options: [
              { value: 'waitlist', label: 'Venteliste' },
              { value: 'pending', label: 'Afventer' },
              { value: 'shownup', label: 'Mødt op' },
              { value: 'requires_attention', label: 'Kræver opmærksomhed' },
              { value: 'completed', label: 'Gennemført' }
            ],
            onChange: handleStatusChange
          }
        ],
        pageable: true,
        sortable: true,
        rowHover: true,
        defaultSortColumn: 'full_name',
        defaultSortDirection: 'asc'
      }
    }
}